import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import LatinExt from "./Anton-Regular-1Ptgg87LROyAm3K8-C8CSKlvPfE.woff2";
import Latin from "./Anton-Regular-1Ptgg87LROyAm3K9-C8CSKlvPfE.woff2";

export const AntonFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LatinExt,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "400",
    },
  },
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
